module.exports = __webpack_public_path__ + "assets/img/sidemenu-item02.04209948.svg";